export const ROOT = '/TrainingCategoryAPI';
export const LIST = `${ROOT}/gettrainingcategorypage`;
